import { Main } from '@sl/base/logic/slots/main';

export class RhombusDropper extends Main { 
    constructor(scene) {
        super(scene);
        this.initialAnimationSpeed = 400;
        this.delayAfterSpin = 1000;
        this.delayAfterLostSpin = 1500;
        this.dropColumnDelay = 122.5;
        this.dropRowDelay = 37.5;
        this.dropInDelay = 500;
        this.initialSpinSpeed = 1;
        this.currentSpinSpeed = this.initialSpinSpeed;
        this.middleReel = Math.round(Config.reels_width / 2);

        this.dropSpeed = 90;
        this.dropInSpeed = 90;
    }

    moveReels(action) {
        if(this.spinStarted) {
            if(action === 'out') {
                this.scene.playSpinSound();
            }
            
            if(action === 'out') {
                this.dropOutReel();
            } else {
                this.dropInReel();
            }
        }
    }

    dropOutReel() {
        let reel = this.reelsContainersObjects[this.middleReel];
        let reelIndex = this.middleReel;
        let symbolIndex = reel.offsetPosition + this.visibleRowsCount; 
        const reelLength = reel.symbols.length;
        let sidesCount = 2;

        if(symbolIndex > reelLength-1) {
            symbolIndex = symbolIndex - reelLength;
        }

        let sideDelay = 0;

        for(let i = 0; i < this.visibleRowsCount; i++) {
            symbolIndex = this.getAfterSymbolIndex(reelIndex, symbolIndex);
           
            const reel = this.reelsContainersObjects[reelIndex];
            const symbol = reel.symbols[symbolIndex];
            
            if(this.visibleCountByReel && this.visibleCountByReel[reelIndex] > symbol.positionOnReel) {
                symbol.alpha = 0;
            }

            let speed = this.dropSpeed * (i+1);

            this.moveSymbolOut(parseInt(reelIndex), symbolIndex, speed);
            
            if(i && i < Config.reels_height-1) {
                let moveFrom = 'left';
                let sideReelIndex;

                if(!sideDelay) {
                    sideDelay = this.dropSpeed / 2 + this.dropSpeed;
                }

                for(let j = 1; j <= sidesCount; j++) { 
                    if(moveFrom == 'left') {
                        sideReelIndex = this.middleReel - 1;
                        moveFrom = 'right';
                    } else {
                        sideReelIndex = this.middleReel + 1;
                        moveFrom = 'left';
                    }

                    let sideReel = this.reelsContainersObjects[sideReelIndex];
    
                    this.moveSideSymbolOut(i, moveFrom, sideReelIndex, sideReel, sideDelay);

                    //move upper symbol also(only reliable on 5x5 rombus)
                    if(i == Config.reels_height-2) {
                        if(moveFrom == 'left') {
                            sideReelIndex += 1;
                        } else {
                            sideReelIndex -= 1;
                        }
                        
                        sideReel = this.reelsContainersObjects[sideReelIndex];
                        this.moveSideSymbolOut(i-1, moveFrom, sideReelIndex, sideReel, sideDelay, 2, (i == this.middleReel && j == sidesCount ));
                    }
                     
                    sideDelay += this.dropSpeed / 2;

                    if(moveFrom == 'left') {
                        sideDelay += this.dropSpeed;
                    }
                }
            } 
        }
    }

    moveSideSymbolOut(row, moveFrom, reelIndex, reel, delay, moveDownBy, last) {
        if(!moveDownBy) { 
            moveDownBy = 1;
        }

        let symbolIndex = reel.offsetPosition + row + 1; 
        const reelLength = reel.symbols.length;

        if(symbolIndex > reelLength-1) {
            symbolIndex = symbolIndex - reelLength;
        }

        symbolIndex = this.getAfterSymbolIndex(reelIndex, symbolIndex);

        const symbol = reel.symbols[symbolIndex];
        
        const destinationY = this.getSymbolCoordinateY(row + moveDownBy, symbol);
        const destinationY2 = this.getSymbolCoordinateY(this.visibleRowsCount, symbol) + this.destinationOffset;

        let timeline = this.scene.tweens.createTimeline();

        timeline.add({
            targets: symbol,
            x: 0, 
            y: destinationY,
            ease: 'Power0',
            delay: delay,
            duration: this.dropSpeed * moveDownBy,
            yoyo: 0,
            repeat: 0,
        });

        timeline.add({
            targets: symbol,
            y: destinationY2,
            ease: 'Power0',
            delay: 0,
            duration: this.dropSpeed * (this.visibleRowsCount - (row + moveDownBy)),
            yoyo: 0,
            repeat: 0,
            onComplete: () => {
                symbol.positionOnReel = -1;
                symbol.alpha = 0;

                if(last) {
                    this.moveReels('in');
                }
            },
        }, this);

        timeline.play();
    }

    moveSymbolOut(reelIndex, symbolIndex, dropSpeed) {
        const reel = this.reelsContainersObjects[reelIndex];
        const symbol = reel.symbols[symbolIndex];
        const destination = this.getSymbolCoordinateY(this.visibleRowsCount, symbol) + this.destinationOffset;

        this.scene.tweens.add({
            targets: symbol,
            y: destination,
            ease: Phaser.Math.Easing.Back.In,
            duration: dropSpeed,
            yoyo: 0,
            repeat: 0,
            onComplete: () => {
                symbol.positionOnReel = -1;
                symbol.alpha = 0;
            },
        });
    }

    async dropInReel() {
        let scenarioExists = Object.keys(this.scene.request.scenario).length;

        while(!scenarioExists) {
            await this.sleep(100);

            scenarioExists = Object.keys(this.scene.request.scenario).length;
        }

        let reel = this.reelsContainersObjects[this.middleReel];
        let reelIndex = this.middleReel;
        let sidesCount = 2;
        let delay = 0;

        for(let i = 0; i < this.visibleRowsCount; i++) {
            this.reelsContainersObjects[reelIndex].offsetPosition = this.scene.request.scenario.reels[reelIndex];
            let symbolIndex = this.reelsContainersObjects[reelIndex].offsetPosition + this.visibleRowsCount - i;
            const reelLength = reel.symbols.length;

            if(symbolIndex > reelLength-1) {
                symbolIndex = symbolIndex - reelLength;
            }

            let moveFrom = 'left';

            symbolIndex = this.getAfterSymbolIndex(reelIndex, symbolIndex);
            var position = (this.visibleRowsCount - 1 - i);
            
            this.moveSymbolIn(parseInt(reelIndex), symbolIndex, delay, position);

            if(!i) {
                delay += this.dropInSpeed;
            }

            const symbol = reel.symbols[symbolIndex];
            
            if(this.visibleCountByReel && (this.visibleRowsCount - this.visibleCountByReel[reelIndex]-1) < position) {
                symbol.alpha = 0;
            } else { 
                symbol.alpha = 1;
            }

            let sidesIncrementer = 2;

            if(i == 2) {
                sidesIncrementer = -2;
            }

            if(i && i < Config.reels_height-1) {
                let sideReelIndex;
                
                delay += this.dropInSpeed;
                

                let reelIndexIncrement = 1; 

                for(let j = 1; j <= sidesCount; j++) { 
                    if(moveFrom == 'left') {
                        sideReelIndex = this.middleReel - reelIndexIncrement;
                        moveFrom = 'right';
                    } else {
                        sideReelIndex = this.middleReel + reelIndexIncrement;
                        moveFrom = 'left';

                        reelIndexIncrement++;
                    }

                    this.reelsContainersObjects[sideReelIndex].offsetPosition = this.scene.request.scenario.reels[sideReelIndex];
                    let sideReel = this.reelsContainersObjects[sideReelIndex];
                    let symbolIndex = this.reelsContainersObjects[sideReelIndex].offsetPosition + this.visibleRowsCount - i - 1;
                    const sideReelLength = sideReel.symbols.length;

                    if(symbolIndex > sideReelLength-1) {
                        symbolIndex = symbolIndex - sideReelLength;
                    }
                    
                    this.moveSymbolIn(parseInt(sideReelIndex), symbolIndex, delay, position);
                        
                    delay += this.dropInSpeed;
                }

                sidesCount += sidesIncrementer;
            }
        }
    }

    moveSymbolIn(reelIndex, symbolIndex, delay, position) {
        const reel = this.reelsContainersObjects[reelIndex];
        const symbol = reel.symbols[symbolIndex];
        symbol.y = this.getSymbolCoordinateY(-1, symbol);
        symbol.x = 0;
        symbol.alpha = 1;

        const moveDownBy = reelIndex != this.middleReel ? position-1 : position;
        
        const destinationY = this.getSymbolCoordinateY(moveDownBy, symbol);
        
        let timeline = this.scene.tweens.createTimeline();

        timeline.add({
            targets: symbol,
            y: destinationY,
            ease: 'Power0',
            delay: delay,
            duration: this.dropInSpeed * (moveDownBy + 1),
            yoyo: 0,
            repeat: 0,
            onComplete: () => {
                if(reelIndex == this.middleReel) {
                    symbol.positionOnReel = position;

                    if(!position) {
                        this.spinStarted = false;
                        this.scene.request.spinStopped();
                        this.scene.afterSpin();
                        /*if(Object.keys(this.reelsContainersObjects).length === reelIndex && i === (this.visibleRowsCount-1)) {
            
                            this.scene.time.delayedCall(delay, () => {
                                this.spinStarted = false;
                                this.scene.request.spinStopped();
                                this.scene.afterSpin();
                            }, {}, this);
                        }*/
                    }
                }
            },
        });

        if(reelIndex != this.middleReel) {
            const destinationY2 = this.getSymbolCoordinateY(position, symbol);
            timeline.add({
                targets: symbol,
                y: destinationY2,
                x: symbol.originalXPosition,
                ease: 'Power0',
                delay: 0,
                duration: this.dropInSpeed,
                yoyo: 0,
                repeat: 0,
                onComplete: () => {
                    symbol.positionOnReel = position;
                },
            });
        }

        timeline.play();
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    createReels() {
        let offsetX = this.symbolsOffsetX();

        this.reelsContainer = this.scene.add.container();
        this.reelsContainer.x = this.scene.cameras.main.centerX;
        this.reelsContainer.y = 0;

        for (const [ reelIndex, reel ] of Object.entries(this.reels)) {
            this.reelsContainersObjects[reelIndex] = {'symbols':[]};

            this.reelsContainersObjects[reelIndex].spinned = 0;
            this.reelsContainersObjects[reelIndex].initialPositions = {};
            let positionOnReel = 0;
            this.reelsContainersObjects[reelIndex].reelStartsAt = 0;
            let appended = 0;

            for (const [ symbolIndex, symbol ] of Object.entries(reel)) {
                const symbolSprite = this.createSymbolSprite(reelIndex, reel, symbolIndex, symbol, appended);

                symbolSprite.positionOnReel = positionOnReel;
                symbolSprite.symbolKey = reel[symbolIndex];

                symbolSprite.y = this.getSymbolCoordinateY(positionOnReel, symbolSprite);
                symbolSprite.x = offsetX;
                symbolSprite.originalXPosition = offsetX;
  
                this.reelsContainer.add(symbolSprite);
                this.reelsContainersObjects[reelIndex].symbols.push(symbolSprite);

                if(this.visibleRowsCount >= positionOnReel) {
                    if(!symbolSprite.appended) {
                        symbolSprite.alpha = 1;
                    }

                    if(positionOnReel > this.visibleRowsCount-1) {
                        symbolSprite.y += this.destinationOffset;
                    }

                    positionOnReel++;
                }
            }
            
            this.reelsContainersObjects[reelIndex].offsetPosition = 0;
            this.reelsContainersObjects[reelIndex].x = offsetX;
            //this.reelsContainersObjects[reelIndex].y = this.reelsOffsetTop;
            this.reelsContainersObjects[reelIndex].name = `reel_${reelIndex}`;
            //this.frameContainer.add(this.reelsContainersObjects[reelIndex]);
            //this.reelsContainer.add(this.reelsContainersObjects[reelIndex]);

            offsetX += this.spaceBetweenReels + this.symbolWidth;
        }

        this.createReelsMask();
    }

    prepareReels() {
        this.currentSpinSpeed = this.initialSpinSpeed;
        if(this.speed) {
            this.speedUpSpin();
        }
        
        this.moveReels('out');
    }

    speedUpSpin() {
        this.currentSpinSpeed = 2;
    }

    resetSpinSpeed() {
        this.currentSpinSpeed = 1;
    }
}